import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurverlagingAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Huurverlaging_aanvragen_svg__a"
      width={23}
      height={25}
      x={5}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M22.6 26.1c-.95.56-2.01.86-3.11.86-2.87 0-5.39-2.05-6.32-4.99h6.8v-4.99h-6.8c.93-2.94 3.45-4.99 6.32-4.99 1.74 0 3.37.74 4.63 2.08l3.64-3.41c-2.12-2.26-5.04-3.65-8.27-3.65-5.66 0-10.37 4.29-11.46 9.98H5v4.99h3.03c1.08 5.69 5.8 9.98 11.46 9.98 2.23 0 4.3-.68 6.07-1.83l-2.96-4.02z"
      />
    </mask>
    <g mask="url(#Huurverlaging_aanvragen_svg__a)">
      <path
        fill="#6FBC85"
        d="m-4.49 5.86 12.24 7.07L14.82.68z"
      />
      <path
        fill="#A8D3AF"
        d="M7.75 12.93.68 25.18 20 20zM5.86 44.49l7.07-12.24L.68 25.18z"
      />
      <path
        fill="#6FBC85"
        d="m25.18 39.32 7.07-12.25L20 20zM20 20l-7.07 12.25 12.25 7.07z"
      />
      <path
        fill="#A8D3AF"
        d="M34.14-4.49 14.82.68l12.25 7.07z"
      />
      <path
        fill="#6FBC85"
        d="M39.32 14.82 27.07 7.75 20 20z"
      />
      <path
        fill="#A8D3AF"
        d="M-4.49 5.86.68 25.18l7.07-12.25z"
      />
      <path
        fill="#6FBC85"
        d="m.68 25.18 12.25 7.07L20 20z"
      />
      <path
        fill="#A8D3AF"
        d="m20 20 12.25 7.07 7.07-12.25zM44.49 34.14l-12.24-7.07-7.07 12.25zM20 20l7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <path
      fill="#00A75D"
      fillRule="evenodd"
      d="M26 25h-3l6 8 6-8h-3v-9h-6z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurverlagingAanvragen);

export default ForwardRef;
